import { AbstractHook } from '@hooks/abstraction';
import { LeadStatusResponse } from '../services/responses/lead-status.response';
import { LeadStatusService } from '../services/lead-status.service';

export class LeadStatusHook extends AbstractHook<LeadStatusResponse, LeadStatusService> {}
